import { render, staticRenderFns } from "./commodityMgmt.vue?vue&type=template&id=8dc1bf92"
import script from "./commodityMgmt.vue?vue&type=script&lang=js"
export * from "./commodityMgmt.vue?vue&type=script&lang=js"
import style0 from "./commodityMgmt.vue?vue&type=style&index=0&id=8dc1bf92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports